const formatInputToInteger = (input = '') => input.replace(/[^\d]/g, '');

export default formatInputToInteger;
